module.exports = __webpack_public_path__ + "static/media/Project02.bf0c7756.jpg";